export default __webpack_public_path__ + "static/media/ab1_logo_black.4b56fd8b.png";